/* eslint-disable @typescript-eslint/naming-convention */
import {type TradableSymbol} from './defaults';

// eslint-disable-next-line @typescript-eslint/no-restricted-types -- Trader DB contracts explicitly distinguish JSON null from omitted fields.
type NullValue = null;

export type TraderDbTraderAccount = {
  brokerIdenifications?: string[];
  location: string;
  computerId?: string;
  dsId: string;
  email: string;
  firstname: string;
  id: string;
  lastname: string;
  legalEntity: LegalEntity;
  legalEntityId: string;
  ocrid?: string;
  phone?: string;
  platformAccess?: any[];
  selfMatchPreventions: SelfMatchPreventions[];
  tags?: any[];
  trainings?: any[];
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
  limits: Limit[];
  clearingStrings?: string[];
  accounts: TraderDBAccount[];
  limitSchedules?: Limit_Schedule[];
  tradableSymbols: TradableSymbol[];
  businessUnit: string;
  accountGroups: AccountGroup[];
};
export type SelfMatchPreventions = {
  brokerId: string;
  brokerName: string;
  exchangeCode: string;
  exchangeId: string;
  exchangeName: string;
  id: string;
  identifier: string;
};

export type TraderLimitQuery = {
  trader_id: string;
  exchange_code: string;
  product_symbol: string;
};

export type TraderLimit = {
  trader_id: string;
  exchange_code: string;
  product_symbol: string;
  max_value_per_order: number;
  net_value_per_day: number;
  max_order_size_fut: number;
  max_gross_value_per_strat: number;
  gross_value_per_day: number;
  max_strat_order_size_fut: number;
  max_strat_order_size_opt: number;
  max_order_size_opt: number;
  max_net_value_per_strat: number;
  max_value_per_strat_order: number;
};

// TraderInfo
export type ProductSpecification = {
  id?: string;
  name: string;
  symbol: string;
  exchangeCode?: string;
  clearingBrokerName?: string;
  clearingBrokerCode?: string;
  exchangeName: string;
  executionBrokers?: ExecutionBroker[];
};

export type ExecutionBroker = {
  id: string;
  brokerId: string;
  brokerName: string;
  account: string;
  clearingString?: string;
  executionPriority?: string | number | NullValue;
  createdAt: string | Date;
  createdBy?: string;
  updatedAt?: string | Date | NullValue;
  updatedBy?: string | NullValue;

};

export type TradeIntention = {
  id: string;
  tradeIntentionName: string;
};

export type TraderDBAccount = {
  id: string;
  code: string;
  description: string;
  action?: string;
  memo?: string;
  isActive: boolean;
  isGDP: boolean;

  neovestAccount: string;
  exchangeName?: string | NullValue;
  clearingString?: string | NullValue;
  lei: string;

  customText2: string;
  customText3: string;
  productSpecifications: ProductSpecification[];
  systemCode?: string;
  tradeIntentions: TradeIntention[];
  accountGroups?: AccountGroup[];
};

export type AccountGroup = {
  id: string;
  name: string;
  action: string;
  type: AccountGroupType;
  accounts: TraderDBAccount[];
  traders?: Trader[];

};

export type AccountGroupType = {
  id: string;
  type: string;
};
export type Trader = {
  businessUnitName: string;
  computerId: string;
  dsId: string;
  email: string;
  firstname: string;
  id: string;
  lastname: string;
  legalEntity: LegalEntity;
  limitIds: string[];
  location: string;
  managerEmail: string;
  name?: string;
  platformAccesses: any[];
  selfMatchPreventions: SelfMatchPreventions[];

  accountGroups: AccountGroup[];
};
export type LegalEntity = {
  businessGroup: string | undefined;
  enterprise: string | undefined;
  entityLead: string | undefined;
  id: string;
  location: string | undefined;
  name: string;
  primaryApprover: string | undefined;
  secondaryApprover: string | undefined;
  updatedAt: string | undefined;
  updatedBy: string | undefined;
  createdAt: string | undefined;
  createdBy: string | undefined;
};
export type Limit = {
  exchangeCode: string;
  exchangeId: string;
  exchangeName: string;
  id: string;
  productSpecificationId: string;
  productSpecificationName: string;
  productSpecificationSymbol: string;
  values: LimitValue[];
  updatedAt: string | undefined;
  updatedBy: string | undefined;
  createdAt: string | undefined;
  createdBy: string | undefined;

};
export type LimitValue = {
  id: string;
  limitTypeId: string;
  limitTypeName: string;
  value: number;
  updatedAt: string | undefined;
  updatedBy: string | undefined;
  createdAt: string | undefined;
  createdBy: string | undefined;
};

export type Limit_Schedule = {
  name: string;
  accountIds: any[];
  brokerNames?: string[];
  brokerId: string;
  id: string;
  description: string;
  limitIds: any[];
  traderIds: any[];
  status: string;
  legalEntityId: string;
  legalEntity: LegalEntity;
  updatedAt: string | undefined;
  updatedBy: string | undefined;
  createdAt: string | undefined;
  createdBy: string | undefined;
  accounts: any[];
  limits: Limit[];
  traders: Trader[];

};
export type TraderInfo = {
  traders: TraderDbTraderAccount[];
};

export const ORDER_LIMIT_MAX_ORDER = {
  Future: 'Max Order Size FUT',
  Option: 'Max Order Size OPT',
  'Futures Spread': 'Max Spread Order Size FUT',
  'Algo_Futures Spread': 'Max Spread Order Size FUT',
  Algo_Future: 'Max Net Size per Day',
  Algo_Option: 'Max Net Size per Day OPT',
  'Algo_Options Spread': 'Max Algo Spread Order Size OPT',
};

export const ORDER_LIMIT_MAX__NET_ORDER = {
  Future: 'Max Net Size per Day',
  Options: 'Max Net Size per Day OPT',
  'Futures Spread': 'Max Spread Order Size FUT',
};
// END TraderInfo

export enum PermissionsGroupNames {
  'Trader-Standard' = 'Trader-Standard',
  'Trader-Advanced' = 'Trader-Advanced',
  'Trader-ReadOnly' = 'Trader-ReadOnly',
  'Trader-AdvancedPlus' = 'Trader-AdvancedPlus',
}

export type EntitlementGroup = {
  id: number;
  name: string;
  activeDirectoryGroup: string;
  description: string;
  users: EntitlementUser[];
};
export type EntitlementUser = {
  id: number;
  upn: string;
  isLocked: boolean;
};
export enum PermissionValue {
  CanAccessData = 'CanAccessData',
  CanTradeFutures = 'CanTradeFutures',
  CanTradeOptions = 'CanTradeOptions',
  CanTradeAlgos = 'CanTradeAlgos',
  CanView = 'CanView',
}

export type UserPermission = {
  data: string;
  type: string;
  value: PermissionValue;
};
